import { FallbackProps } from 'react-error-boundary'
import { RefreshIcon } from '@heroicons/react/solid'
import { Aside, Button, Main, Paragraph, StickyFooter } from 'src/components'

export function ErrorFallback(props: FallbackProps) {
  return (
    <>
      <Aside title="Error" disableLogin hideExtraRow />

      <Main>
        <div role="alert" className="grid items-center grid-cols-1 gap-6">
          <Paragraph className="col-span-full">
            Something went wrong: {props.error.message}
          </Paragraph>

          <StickyFooter>
            <Button
              onClick={props.resetErrorBoundary}
              label="reload"
              icon={<RefreshIcon />}
              iconPosition="left"
            />
          </StickyFooter>
        </div>
      </Main>
    </>
  )
}
